/**
 * Picks the three actions the Copilot window promotes to large copy-labelled
 * buttons: the IN, CONTINUE and OUT actions.
 *
 * Action values arrive in two shapes — bare graphic-level keys ("IN") and
 * caption-scoped ids ("gfx_PermScore_IN") — so both are matched, the same pair
 * the form library's own icon lookup recognises. An exact key or an
 * underscore-delimited suffix counts; nothing else, so TIMEOUT is not an OUT.
 *
 * Returns each option untouched; the window shows its `label` (the action's
 * v_actions `name`) in upper case.
 */
const matches = (value, canonical) => {
  const v = String(value ?? '');
  return v === canonical || v.endsWith(`_${canonical}`);
};

const find = (options, canonical) =>
  options.find((o) => matches(o?.value, canonical)) || null;

export const pickPrimaryActions = (actionEnumOptions) => {
  const options = Array.isArray(actionEnumOptions) ? actionEnumOptions : [];

  return {
    animateIn: find(options, 'IN'),
    continueAction: find(options, 'CONTINUE'),
    animateOut: find(options, 'OUT'),
  };
};
